import React, { Component } from "react";
import "./DeleteExitModal.css";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

export default class UserAdminModal extends Component {
  handleChange = (e) => {
    let { name, value } = e.target;
    const activeItem = { ...this.state.activeItem, [name]: value };
    this.setState({ activeItem });
  };

  getUserStr = (users) => {
    var i;
    var userStr = [];
    for (i = 0; i < users.length; i++) {
      if (i === users.length - 1 && i !== 0) {
        userStr.push(", and ");
      } else if (i !== 0) {
        userStr.push(", ");
      }
      userStr.push(<b key={users[i].username}>{users[i].username}</b>);
    }
    return userStr;
  };
  render() {
    const { toggle, toggleName, onSave, users, isAdmin } = this.props;

    return (
      <Modal
        modalClassName="Modal"
        isOpen={true}
        toggle={function () {
          return toggle(toggleName);
        }}
      >
        <ModalHeader>
          {" "}
          Admin rights{" "}
          <button
            className="delete_exit_close_button"
            onClick={function () {
              return toggle(toggleName);
            }}
          >
            ×
          </button>
        </ModalHeader>
        <ModalBody>
          {isAdmin ? (
            <>
              Take away admin rights from user <b>{users[0].username}</b>?
            </>
          ) : (
            <>
              Give admin rights to user <b>{users[0].username}</b>?
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="save_button"
            color="success"
            onClick={() => {
              let action = isAdmin ? "remove-admins" : "add-admins";
              onSave(users[0], action);
            }}
          >
            Confirm
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
